import { AppService } from './app.service';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/forkJoin'
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router, Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { environment } from '../../environments/environment';

@Injectable()
export class GymResolver implements Resolve<any> {
    constructor(private appService: AppService, private router: Router) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
        let language = route.params['language'];
        if (!environment.allowedLanguages[language]) {
            this.router.navigate(['/not-found']);
            return null;
        }
        return Observable.forkJoin(
            this.appService.getGym(language),
            this.appService.getPackageTypes(language)
        ).map(results => {
            let data: any = {};
            if (results[0]) {
                let gym = results[0].json();
                data['gym'] = (gym[0] ? gym[0] : {});
            }
            if (results[1]) {
                data['packageTypes'] = results[1].json();
            }
            return data;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/providers/gym-resolver.service.ts